import { createContext, PropsWithChildren, useContext, useState } from "react";

type ContextType = {
  visible: boolean;
  show: () => void;
  dismiss: () => void;
};

const Context = createContext<ContextType | null>(null);

export default function useModalContext() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("Missing ModalContextProvider");
  return ctx;
}

export function ModalContextProvider({ children }: PropsWithChildren) {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const dismiss = () => setVisible(false);
  return (
    <Context.Provider value={{ visible, show, dismiss }}>
      {children}
    </Context.Provider>
  );
}
